import React, { useState } from 'react'
import customRequest from '../../helpers/customRequest'
import { Link } from 'react-router-dom'
import BeatLoader from 'react-spinners/BeatLoader'
import getURLParameters from '../../helpers/getURLParams';
import message from '../../components/message/message';
import buildQuery from '../../helpers/buildQuery';

class Students extends React.Component
{
    state = {
        status : {
            active : null,
            used : null,
            transferred: null,
            transferredUsed: null
        },
        
        students: {
            active : [],
            shared : [],
            archived : [],
            transferred: []
        },
        allChecked: false,
        loading: true
    }

    componentDidMount()
    {
        let promises = [customRequest.get("/api/students"), customRequest.get("/api/status")]
        Promise.all(promises)
        .then(([{data: students}, {data: status}]) =>
        {
            if (status.valid == false || students.valid == false) {
                message.error(status.message, students.message)
            }
            this.setState({
                status : {
                    available : status.available,
                    active : status.active,
                    used : status.used,
                    transferred: status.transferred,
                    transferredUsed: status.transferredUsed
                },
                students : {
                    active : students.active ?? [],
                    shared : students.shared ?? [],
                    archived : students.archived ?? [],
                    transferred: students.transferred ?? []
                },
                loading: false
            })
        })
        
    }

    render()
    {
        var {students, status, allChecked, loading} = this.state


        return (
            <React.Fragment>
                {status.used === 0 && status.active === 0 && status.available == 0 && students?.shared?.length === 0?
                    <div class="alert alert-danger">Your subscription has expired you must <Link to="/subscribe">purchase more students</Link> to continue using the platform.</div>
                    :
                    ""
                }
                {status.available < 0 ?
                
                <React.Fragment>
                    {status.active > 0 ? 
                    <div class="alert alert-danger">Due to your previous subscription expiring, you have exceeded the number of students allowed on your account. Your student data has been preserved, but you will not have access to start any exercise with your students until you <strong>delete or archive {Math.abs(status.available)} students</strong> below or <Link to="/subscribe">purchase more students</Link> to continue using the platform.</div>
                    :

                    <div class="alert alert-danger">Your subscription has expired you must <Link to="/subscribe">purchase more students</Link> to continue using the platform.</div>
                    }
                </React.Fragment>
                :
                ""}
                
                <h1>Students</h1>
                {(students.active.length + students.archived.length + students.shared.length + students.transferred.length) > 1 ? 
                    <div class = "offset-9 col-3">
                    <input placeholder = "Search Students" id = "student-search" class = "form-control float-right student-search" onChange={() =>
                    {
                        // Declare variables 
                        var input = document.getElementById("student-search");
                        var filter = input.value.toUpperCase();

                        var studentLists = document.getElementsByClassName("student-list");
                        if (studentLists != null)
                        {
                            for (let studentList of studentLists) {

                                var nameSpan = studentList.querySelector(".student-name")
                                var txtValue = nameSpan.textContent
                                
                                if (txtValue.toUpperCase().indexOf(filter) > -1)
                                    studentList.style.display = "";
                                
                                else
                                    studentList.style.display = "none";
                            }
                        }
                    }} />
                </div>
                : ""}

                <h3 class = "subheader-text">Active Students</h3>
                
                { students?.active?.length === 0 ?
                
                <React.Fragment>
                {
                    loading ?
                    <BeatLoader
                        size={10}
                        color={"#123abc"}
                        loading={loading} />
                    
                    : <p>You do not currently have any students under your account. Please click the link below to add students.</p>
                }
                
                </React.Fragment>
                
                
                : 
                    
                        
                        <form id = "students-form" class = "form-horizontal form-validate" noValidate method = "get">
                            <ul id = "checkbox-list" class = "list-group text-left mb-3">
                                {
                                    students?.active?.map((student) =>
                                    {
                                        let commonQuery = buildQuery({student: student.name})
                                        return <li class = "list-group-item action-list student-list" key = {student.name}>
                                                    <input class = "checkbox-list-item" type = "checkbox" id = {"checkbox-" + student.name} name = "students[]" value = {student.name} />
                                                    
                                                    <label class = "break-words student-name" role = "button" for = {"checkbox-" + student.name}>{student.name}</label>
                                                    
                                                    <span class = "float-right">
                                                        <Link to = {`/students/records/phonics?${commonQuery}`} class = "action-link">Records</Link>
                                                        
                                                        <Link to = {`/students/edit?${commonQuery}`} class = "action-link">Edit</Link>
                                                        
                                                        <Link to = {`/students/${student.hasDoneProbe ? "archive" : "delete" }?${commonQuery}`} class = "action-link">{student.hasDoneProbe ? "Archive" : "Delete" }</Link>
                                                    </span>
                                                </li>
                                    })
                                }

                            </ul>
                            
                            <div class = "row">
                                <div class = "col-12 text-left">
                                    <input class = "checkbox-shortcut" type = "checkbox" id = "checkbox-shortcut" name = "shortcut" checked={allChecked} onChange={() => {
                                        var checkboxes = document.getElementsByClassName('checkbox-list-item')
                                        for (var checkbox of checkboxes)
                                            checkbox.checked = !allChecked

                                        this.setState({allChecked: !allChecked})
                                    }}/>
                                    
                                    <label role = "button" for = "checkbox-shortcut">Select all</label>
                                </div>
                            </div>
                            
                            <div class = "row">
                                <div class = "col-12 subheader-text">
                                    <span>With selected students:</span>
                                    
                                    <br class = "d-block d-sm-none" />
                                    
                                    <button type = "submit" class = "btn btn-secondary btn-md button-inline" onClick={() => {
                                        document.getElementById('students-form').action = "/students/share"
                                    }}>Share</button>
                                    
                                    <button type = "submit" class = "btn btn-secondary btn-md button-inline" onClick={() => {
                                        document.getElementById('students-form').action = "/students/transfer"
                                    }}>Transfer</button>
                                </div>
                            </div>
                        </form>
                }

                {loading ? "" : 
                <React.Fragment>
                    <div class = "row prefooter-text">
                        <div class = "col-6 col-sm-4">
                            <p>Students Purchased: {status.active}</p>
                            {status.transferred > 0 ?<p>Students Transferred: {status.transferred}</p> : ""}
                        </div>
                        
                        <div class = "col-6 col-sm-4">
                            <p>Students Used: {status.used}</p>
                            {status.transferredUsed > 0 ? <p>Students Transferred Used: {status.transferredUsed}</p> : ""}
                        </div>
                        
                        <div class = "col-6 offset-3 col-sm-4 offset-sm-0">
                            <p>Students Available: {status.available}</p>
                        </div>
                        
                    </div>

                    <div class = "row prefooter-text">
                        {status.available > 0 ? 
                        <div class = "col-10 offset-1 col-sm-6 offset-sm-0 col-md-4 offset-md-2">
                            
                            <Link to = "/students/add" class = "btn btn-secondary btn-lg">Add Student</Link>
                        </div>
                        : ""}
                        
                        <div class = {`col-10 offset-1 col-sm-6 offset-sm-${status?.available > 0 ? "0" : "3"} col-md-4 offset-md-${status?.available > 0 ? "0" : "4"}`}>
                            <Link to = "/students/share/manage" class = "btn btn-secondary btn-lg">Manage Sharing Settings</Link>
                            {/* col-10 offset-1 col-sm-6 offset-sm-3 col-md-4 offset-md-4 */}
                        </div>
                    </div>
                </React.Fragment>
                }
                {students.shared.length > 0 ?
                    <React.Fragment>
                        <hr />
                        <h3 class = "subheader-text">Shared Students</h3>

                        <ul class = "list-group text-left subheader-text">
                            {
                                students.shared.map((student) =>
                                {
                                    let commonQuery = buildQuery({student: student.name, customer: student.owner})
                                    return (
                                        <li class = "list-group-item action-list student-list">
                                            <span class = "break-words student-name">{student.name} (from {student.owner})</span>
                                            
                                            <span class = "float-right">
                                                { student.canRead ? <Link to = {`/students/records/phonics?${commonQuery}`} class = "action-link">Records</Link> : "" }
                                                { student.canWrite ? <Link to = {`/students/edit?${commonQuery}`} class = "action-link">Edit</Link> : "" }
                                                <Link to = {`/students/share/remove?${commonQuery}`} class = "action-link">Remove</Link>
                                            </span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </React.Fragment>
                : ""}

                {students.transferred.length > 0 ?
                    <React.Fragment>
                        <hr />
                        <h3 class = "subheader-text">Transferred Students</h3>

                        <ul class = "list-group text-left subheader-text">
                            {
                                students.transferred.map((student) =>
                                {
                                    let commonQuery = buildQuery({student: student.name, customer: student.owner})
                                    return (
                                        <li class = "list-group-item action-list student-list">
                                            <span class = "break-words student-name">{student.name} (from {student.owner})</span>
                                            
                                            <span class = "float-right">
                                                <Link to = {`/students/records/phonics?${commonQuery}`} class = "action-link">Records</Link>
                                                <Link to = {`/students/edit?${commonQuery}`} class = "action-link">Edit</Link>
                                            </span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </React.Fragment>
                : ""}
                
                {students.archived.length > 0 ?
                    <React.Fragment>
                        <hr />

                        <h3 class = "subheader-text">Archived Students</h3>

                        <ul class = "list-group text-left">
                            {
                                students.archived.map((student) =>
                                {
                                    let commonQuery = buildQuery({student: student.name})
                                    return (
                                        <li class = "list-group-item action-list student-list">
                                        <span class = "break-words student-name">{student.name}</span>
                                        
                                        <span class = "float-right">
                                            <Link to = {`/students/records/phonics?${commonQuery}`} class = "action-link">Records</Link>
                                            
                                            <Link to = {`/students/edit?${commonQuery}`} class = "action-link">Edit</Link>
                                        </span>
                                    </li>
                                    )
                                })
                            }
                        </ul>

                        <div class = "row prefooter-text">
                            <div class = "col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                                <p>If you would like to restore an archived student, please <a href = "https://greatleaps.com/index.php?main_page=contact_us">contact us using our contact form</a> for assistance.</p>
                            </div>
                        </div>
                    </React.Fragment>
                : ""}
            </React.Fragment>
        )
    }
}

export default Students
